import { Heap } from '@datacamp/exercise-tracking';
import { useEffect, useMemo } from 'react';
import { supportedLanguageCodes } from '../constants/supportedLanguageCodes';
const getSubtitleLanguage = _ref => {
  let {
    selectedSubtitle,
    targetLanguage
  } = _ref;
  if (selectedSubtitle || targetLanguage === 'en') {
    return selectedSubtitle;
  }
  if (targetLanguage === 'zh-tw') {
    return 'zh-TW';
  }
  return supportedLanguageCodes.find(code => code === targetLanguage) || 'en';
};
export const useSubtitleLanguage = _ref2 => {
  let {
    onSetSubtitle,
    selectedSubtitle,
    userLanguage
  } = _ref2;
  const targetLanguage = userLanguage.slice(0, 2);
  const subtitlesLanguage = useMemo(() => getSubtitleLanguage({
    selectedSubtitle,
    targetLanguage
  }), [targetLanguage, selectedSubtitle]);
  useEffect(() => {
    if (selectedSubtitle || !subtitlesLanguage) {
      return;
    }
    Heap.trackEvent({
      heapEventProperties: {
        // @ts-expect-error this is not a valid event_category but is still allowed by Heap https://datacamp.atlassian.net/wiki/spaces/PRODENG/pages/2173796462/Heap+Event+properties#Event-categories
        event_category: 'subtitle',
        subtitles_language: subtitlesLanguage,
        user_language: userLanguage,
        was_language_supported: subtitlesLanguage === targetLanguage || subtitlesLanguage === 'zh-TW'
      },
      name: 'VideoExercise - Player Default Subtitles Set'
    });
    onSetSubtitle({
      selectedSubtitle: subtitlesLanguage
    });
  }, [targetLanguage, onSetSubtitle, subtitlesLanguage, userLanguage, selectedSubtitle]);
  return subtitlesLanguage;
};